// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE

import * as $$Array from "bs-platform/lib/es6/array.js";
import * as FFT$WebAudio from "../FFT/FFT.bs.js";

function toTypedArray(floatArray) {
  var realCoefficients = new Float32Array($$Array.map((function (x) {
              return x.re;
            }), floatArray));
  var imaginaryCoefficients = new Float32Array($$Array.map((function (x) {
              return x.im;
            }), floatArray));
  return [
          realCoefficients,
          imaginaryCoefficients
        ];
}

function calculateCoefficients(samples) {
  return toTypedArray(FFT$WebAudio.fft($$Array.map((function (value) {
                        return {
                                re: value,
                                im: 0.0
                              };
                      }), samples)));
}

export {
  toTypedArray ,
  calculateCoefficients ,
  
}
/* No side effect */
